import type { RGProduct } from "@raumagarn/formatters";
import { TAGS } from "../config";

export const getProductTag = (product: RGProduct) => {
	if (product.pr_promo_new === "1" || product.showAsNew) return TAGS.new;
	if (product.showAsOnSale) return TAGS.sale;
	if (product?.pr_product_type_outlet === "1") return TAGS.outlet;
	if (product.pr_promo_comingsoon === "1") return TAGS.comingSoon;
	if (product.pr_free_recipe_freeRecipe === "1") return TAGS.free;

	return null;
};

const getAllProductTags = (product: RGProduct) => {
	const allTags = [];

	const newProduct = product.pr_promo_new === "1" || product.showAsNew;
	const saleProduct = product.showAsOnSale;
	const outlet = product?.pr_product_type_outlet === "1";
	const isComingSoon = product.pr_promo_comingsoon === "1";

	if (outlet) allTags.push(TAGS.outlet);
	if (saleProduct) allTags.push(TAGS.sale);
	if (newProduct) allTags.push(TAGS.new);
	if (isComingSoon) allTags.push(TAGS.comingSoon);

	return allTags;
};

export const getProductTags = (product: RGProduct) => {
	const tags = getAllProductTags(product);
	const activeTag = getProductTag(product);

	return {
		list: tags,
		activeTag,
	};
};

export const getYarnWeightAndLength = (product: RGProduct) => {
	const weightAndLength = product.pr_length_length
		? `${product.pr_length_length} / ${product.pr_display_weight_value}`
		: product.pr_display_weight_value;

	return weightAndLength;
};

export const getYarnType = (product: RGProduct): string[] | undefined => {
	if (product.pr_product_type_type !== "yarn") return;

	const uniqueYarnCategories = [
		...new Set(
			(product.categories?.flatMap((e) => e.name) ?? []).filter((x): x is string => Boolean(x)),
		),
	];

	const firstCategoryName = product.categoryName?.at(0); // Category "Garn" should be ingored
	const lastCategoryName =
		uniqueYarnCategories.length > 2 ? product.categoryName?.at(-1) : undefined; // Category with same name as product name should be ignored only if there are more than 2 categories total

	const filteredYarnCategories = uniqueYarnCategories.filter(
		(category) =>
			category.toLowerCase() !== firstCategoryName?.toLowerCase() &&
			category.toLowerCase() !== lastCategoryName?.toLowerCase(),
	);

	return filteredYarnCategories;
};
